import API from 'utils/API'
import {
  CORE_API_LOG_REQUEST,
  CORE_API_LOG_SUCCESS,
  CORE_API_LOG_FAILURE,
  CORE_API_LOG_DETAIL_REQUEST,
  CORE_API_LOG_DETAIL_SUCCESS,
  CORE_API_LOG_DETAIL_FAILURE,
  CORE_API_LOG_NAMES_SUCCESS,
} from 'constants/ActionTypes'

export const coreApiLogRequest = () => ({
  type: CORE_API_LOG_REQUEST,
})

export const coreApiLogSuccess = (data, meta) => ({
  type: CORE_API_LOG_SUCCESS,
  data,
  meta,
})

export const coreApiLogFailure = errorMessage => ({
  type: CORE_API_LOG_FAILURE,
  errorMessage,
})

export const coreApiLogDetailRequest = () => ({
  type: CORE_API_LOG_DETAIL_REQUEST,
})

export const coreApiLogDetailSuccess = data => ({
  type: CORE_API_LOG_DETAIL_SUCCESS,
  data,
})

export const coreApiLogDetailFailure = errorMessage => ({
  type: CORE_API_LOG_DETAIL_FAILURE,
  errorMessage,
})

export const coreApiLogNamesSuccess = data => ({
  type: CORE_API_LOG_NAMES_SUCCESS,
  data,
})

export const fetchCoreApiLog = params => (
  (dispatch) => {
    dispatch(coreApiLogRequest())
    const url = `${process.env.APP_CONFIG.api_url}/cms/core-log${params || ''}`
    return API.get(url).then(
      (response) => {
        const { data, meta } = response.data
        if (meta.status) {
          dispatch(coreApiLogSuccess(data, meta))
        } else {
          dispatch(coreApiLogFailure(meta.message))
        }
      },
    ).catch((err) => {
      dispatch(coreApiLogFailure(err.message))
    })
  }
)

export const fetchCoreApiLogDetail = id => (
  (dispatch) => {
    dispatch(coreApiLogDetailRequest())
    const url = `${process.env.APP_CONFIG.api_url}/cms/core-log/${id}`
    return API.get(url).then(
      (response) => {
        const { data, meta } = response.data
        if (meta.status) {
          dispatch(coreApiLogDetailSuccess(data))
        } else {
          dispatch(coreApiLogDetailFailure(meta.message))
        }
      },
    ).catch((err) => {
      dispatch(coreApiLogDetailFailure(err.message))
    })
  }
)

export const fetchCoreApiLogNames = () => (
  (dispatch) => {
    const url = `${process.env.APP_CONFIG.api_url}/cms/core-log/api-names`
    return API.get(url).then(
      (response) => {
        const { data, meta } = response.data
        if (meta.status) {
          dispatch(coreApiLogNamesSuccess(data || []))
        }
      },
    ).catch(() => {})
  }
)
